import { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { PartDetailsTab } from 'parts/components/PartDetails';
import { useSelectedQuotePartContext } from 'quotes/states';
import { IQuotePart } from 'quotes/types';

import { QuotePartInlineActionDrawer } from './enums';

interface IProps {
  setDefaultQuotePartDetailsTab?: Dispatch<SetStateAction<PartDetailsTab>>;
}

export const useTableInlineActions = ({ setDefaultQuotePartDetailsTab }: IProps = {}) => {
  const [activeInlineActionDrawer, setActiveInlineActionDrawer] =
    useState<QuotePartInlineActionDrawer | null>(null);

  const { selectedQuotePart, clearSelectedQuotePart, selectQuotePart } =
    useSelectedQuotePartContext();

  // Next Line re-selects the part with the drawer still open, so this follows it.
  const editLineId =
    QuotePartInlineActionDrawer.EDIT_LINE === activeInlineActionDrawer
      ? selectedQuotePart?.id ?? null
      : null;

  const openInlineActionDrawer = useCallback(
    (quotePart: IQuotePart, action: QuotePartInlineActionDrawer) => {
      setActiveInlineActionDrawer(action);
      selectQuotePart(quotePart);
    },
    [selectQuotePart]
  );

  const onCloseInlineActionDrawer = () => {
    setActiveInlineActionDrawer(null);
    clearSelectedQuotePart();
    resetToDefaultTabs();
  };

  const resetToDefaultTabs = () => {
    if (activeInlineActionDrawer === QuotePartInlineActionDrawer.DETAILS) {
      setDefaultQuotePartDetailsTab && setDefaultQuotePartDetailsTab(undefined);
    }
  };

  return {
    activeInlineActionDrawer,
    openInlineActionDrawer,
    onCloseInlineActionDrawer,
    editLineId,
  };
};
